import { render, staticRenderFns } from "./PartnerWithUs.vue?vue&type=template&id=f9a7f09a&scoped=true&"
import script from "./PartnerWithUs.vue?vue&type=script&lang=js&"
export * from "./PartnerWithUs.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWithUs.vue?vue&type=style&index=0&id=f9a7f09a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a7f09a",
  null
  
)

export default component.exports